import api from "./client";
import { GoerProfile } from "../types";

export const getMyProfile = () => {
  return api.get<GoerProfile>("/profiles/me");
};

export const updateMyProfile = (data: Partial<GoerProfile>) => {
  return api.put<GoerProfile>("/profiles/me", data);
};
